import { TextField, Autocomplete } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { ParamTimeZones } from '@utils/constants'
import React, { useState } from 'react'
import styles from './AddNewPortalForm.module.scss'
import PropTypes from 'prop-types'
import ClinicvuService from 'services/Clinicvu/Clinicvu.service'

const AddNewPortalForm = ({ setShowNew, goBack, currPortal }) => {
  // Patient Information Data
  const [name, setName] = useState('' || currPortal?.name)
  const [timezone, setTimezone] = useState('' || currPortal?.timezone)

  const savePortal = async (e) => {
    e.preventDefault()
    try {
      const res = await ClinicvuService.createOrganization(name, timezone)
      if (res.status !== 200) {
        throw new Error('Was unable to save user information with id')
      }
      setShowNew(false)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <form className={styles['enrollment-form']}>
          {/* Patient Info */}
          <div className={styles['info-container']}>
            <div className={styles['info-container__row']}>
              <TextField
                label="Portal Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className={styles.email}
                size="small"
                style={{ marginLeft: '15px' }}
                disabled={!!currPortal}
              />
            </div>
            <div className={styles['info-container__row']}>
              <label className={styles['date-of-birth']}>
                Timezone
                <Autocomplete
                  value={timezone}
                  onChange={(event, newValue) => {
                    setTimezone(newValue)
                  }}
                  options={Object.keys(ParamTimeZones)}
                  className={styles.param__input}
                  disabled={!!currPortal}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password'
                      }}
                    />
                  )}
                />
              </label>
            </div>
            <div
              className={`${styles['info-container__row']} ${styles['btns-row']}`}
            >
              <div>
                <button
                  onClick={goBack}
                  className={`${styles['enrollment-form__btn']} ${styles.cancel}`}
                >
                  Cancel
                </button>
                <button
                  onClick={(e) => savePortal.mutate(e)}
                  type="submit"
                  className={styles['enrollment-form__btn']}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </LocalizationProvider>
    </div>
  )
}

AddNewPortalForm.propTypes = {
  setShowNew: PropTypes.func,
  goBack: PropTypes.func,
  currPortal: PropTypes.object
}

export default AddNewPortalForm
